'use strict';

Object.defineProperty(exports, '__esModule', {
    value: true
});
exports['default'] = NoSpaceFilter;

function NoSpaceFilter() {
    return function (value) {
        return !value ? '' : value.replace(/ /g, '');
    };
}

NoSpaceFilter.$inject = [];
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./resources/assets/js/src/filters/nospace.js
 ** module id = 12
 ** module chunks = 0
 **/